import React, { useState, useEffect, useRef } from 'react';
import { QuestionGameVoteType, QuestionGameVoteCallback, QuestionGameUser, getConfiguration } from '../models';
import { EmptyPhoto, Photo } from '../components';
import { IconVoteDown, IconVoteUp, IconConfusedFace } from '../utils';

interface QuestionGameProps {
    openInNewTab: boolean;
    className: string;
    pageLoading: boolean;
    user: QuestionGameUser;
    onQuestionGameVote: QuestionGameVoteCallback;
    onResetFilter: (() => void);
}

export const QuestionGameCard = ({ user, className, pageLoading, onQuestionGameVote, onResetFilter, openInNewTab }: QuestionGameProps) => {
    if (pageLoading || user.loading) {
        return <EmptyPhoto className={className} />
    }

    if (user.photo === null) {
        return <a className={`${className} app-empty-photo`}>
            <IconConfusedFace />
            <span>Daugiau narių pagal pasirinktus kriterijus nėra</span>
            <button className='button' onClick={onResetFilter}>Rodyti daugiau</button>
        </a>;
    }

    return <Photo photo={user.photo} openInNewTab={openInNewTab} className={className} tooltip={`${user.name} (${user.age} m., ${user.city})`} link={`${getConfiguration().serviceEndpoint}/narys.cfm?narys=${user.userId}`}>
        <IconVoteDown onClick={(event) => {
            onQuestionGameVote(user.userId, QuestionGameVoteType.no)
            event.preventDefault();
        }} />
        <IconVoteUp onClick={(event) => {
            onQuestionGameVote(user.userId, QuestionGameVoteType.yes)
            event.preventDefault();
        }} />
    </Photo>;
};